/**
 * YouTube Suite — wraps existing YouTube tools + hero Channel Assessment.
 */
import { Youtube, FileText, Image as ImageIcon, Pen, Tag, Hash, BarChart3, Users,
  Calendar, Mic, Repeat, Upload,
} from "lucide-react";
import SuiteHub from "@/components/premium/SuiteHub";

const SECTIONS = [
  {
    title: "Channel growth",
    tools: [
      { name: "Channel Assessment", desc: "Paste URL → 25-metric audit + 90-day plan", Icon: Youtube, to: "/youtube-suite/channel-assessment", badge: "NEW" },
      { name: "Performance Analyzer", desc: "Video-level deep dive", Icon: BarChart3, to: "/studio/analytics", badge: "LIVE" },
      { name: "Content Calendar", desc: "30-day publishing calendar", Icon: Calendar, to: "/studio/calendar", badge: "LIVE" },
      { name: "Competitor Analysis", desc: "Benchmark vs 5 channels", Icon: Users, to: "/youtube-suite/competitor-analysis", badge: "LIVE" },
    ],
  },
  {
    title: "Video creation",
    tools: [
      { name: "Title Generator", desc: "Hook-driven viral titles", Icon: Pen, to: "/tools/youtube", badge: "LIVE" },
      { name: "Description Generator", desc: "SEO-optimized descriptions", Icon: FileText, to: "/tools/youtube", badge: "LIVE" },
      { name: "Hashtag Generator", desc: "Niche-perfect hashtag packs", Icon: Hash, to: "/free/hashtag-generator", badge: "LIVE" },
      { name: "Script Generator", desc: "Hook + body + CTA", Icon: Pen, to: "/tools/content", badge: "LIVE" },
      { name: "Thumbnail Generator", desc: "AI thumbnail concepts", Icon: ImageIcon, to: "/ai-image", badge: "LIVE" },
      { name: "Thumbnail Brief", desc: "AI-generated thumbnail copy", Icon: ImageIcon, to: "/youtube-suite/thumbnail-brief", badge: "LIVE" },
    ],
  },
  {
    title: "Optimization & repurpose",
    tools: [
      { name: "Video SEO Assistant", desc: "Gemini 3 — titles, descriptions, tags", Icon: Tag, to: "/studio/seo", badge: "LIVE" },
      { name: "Transcript / Captions", desc: "Video → timestamped transcript + SRT", Icon: Mic, to: "/tools/auto-captions", badge: "LIVE" },
      { name: "Video Repurpose", desc: "Long video → reels + tweets + blog", Icon: Repeat, to: "/youtube-suite/video-repurpose", badge: "LIVE" },
      { name: "Upload Planner", desc: "Best time + day suggestions", Icon: Upload, to: "/youtube-suite/upload-planner", badge: "LIVE" },
    ],
  },
];

export default function PremiumYouTubeSuite() {
  return (
    <SuiteHub
      testId="youtube-suite"
      eyebrow="YouTube Suite"
      title="Grow your channel — without burnout"
      subtitle="Audit, plan, create and analyze. One place for every creator workflow."
      sections={SECTIONS}
    />
  );
}
